import React from 'react'
import PropTypes from 'prop-types'

import { Flex, Image, Link, Text } from 'Components/UI'

import { PROJECT, WORK } from 'Constants/Paths'

import {
  Container,
  Header,
  HeaderIcon,
  ImageHolder,
  ProjectLink,
  Wrapper,
} from './styles'
import System from './System'

function ProjectSlide({ project }) {
  return (
    <Container>
      <Flex height="100%">
        <Wrapper backgroundColor={project.background.hex}>
          <Header>
            <Link href={project?.slug ? PROJECT(project.slug) : WORK}>
              <ProjectLink>
                <Text as="h3" bold fontSize={[22, 22, 22, 30]} mr={16} white>
                  {project.title}

                  <HeaderIcon />
                </Text>
              </ProjectLink>
            </Link>

            <Flex>
              {project.platforms.map(platform => (
                <System
                  key={`${project.id}${platform.id}`}
                  platform={platform}
                />
              ))}
            </Flex>
          </Header>

          <ImageHolder>
            {/* Slides run ~1/3 of the wide wrapper on desktop (~450px). */}
            <Image
              alt={
                project?.title
                  ? `Screenshots of application ${project.title}`
                  : ''
              }
              image={project?.image}
              lazy
              sizes="(max-width: 768px) 90vw, 450px"
            />
          </ImageHolder>
        </Wrapper>
      </Flex>
    </Container>
  )
}

ProjectSlide.propTypes = {
  project: PropTypes.object.isRequired,
}

export default ProjectSlide
